export default __webpack_public_path__ + "static/char-s-46-ja-1d910e524be2490ff1bc474938a5ebb6.png";